import { Stack, StackProps } from '@chakra-ui/react'
import { FC } from 'react'

const SectionStack: FC<StackProps> = ({ children, ...rest }) => {
  return (
    <Stack p={{ base: '6', sm: '8', md: '10', lg: '12' }} spacing="4" {...rest}>
      {children}
    </Stack>
  )
}

export default SectionStack
